import { jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { ToastContext } from "./ToastContext.js";
import { ToastsUpdatedEvent } from "./ToastMaster.js";
import { isToastMaster } from "./utils.js";
import "../../sass/sass.js";
import "../../utils/constants.time.js";
function ToastContextProvider(props) {
  const { toastMaster = {} } = props, toastMasterPresent = isToastMaster(toastMaster), [toasts, setToasts] = useState([]);
  return useEffect(
    () => {
      if (!toastMasterPresent)
        return;
      function updateToasts(event) {
        setToasts(event.detail);
      }
      return toastMaster.addEventListener(ToastsUpdatedEvent.type, updateToasts, {
        passive: !0
      }), function() {
        toastMaster.removeEventListener(ToastsUpdatedEvent.type, updateToasts);
      };
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps --
     *   should only fire on initial render
     */
    []
  ), /* @__PURE__ */ jsx(ToastContext.Provider, { value: { toastMaster, toasts }, children: props.children });
}
export {
  ToastContextProvider
};
//# sourceMappingURL=ToastContextProvider.js.map
